import React, { useCallback, useEffect } from 'react';

import { useRouter } from 'next/router';

import { useAuth } from '@contexts/AuthUserContext';

export const withPublic = (Component: React.FC) => () => {
  const { authUser, loading } = useAuth();
  const router = useRouter();

  const redirect = useCallback(() => {
    if (loading) return;

    if (authUser?.uid) router?.replace('/home');
  }, [loading, authUser?.uid, router]);

  useEffect(() => {
    redirect();
  }, [redirect]);

  return <Component />;
};
